import React, { useState } from 'react';

// Accordeon de l'onglet Analyse (V2, namespace .opms). Reprend le comportement de
// l'atome legacy AnalyseAccordion : controle/non-controle, verrou (entete grisee +
// cadenas) avec option lockedKeepOpen (corps visible malgre le verrou).
interface OperationAnalyseAccordionProps {
  title: string;
  locked?: boolean;
  lockedHint?: string;
  lockedKeepOpen?: boolean;
  open?: boolean;
  onToggle?: (next: boolean) => void;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

const OperationAnalyseAccordion: React.FC<OperationAnalyseAccordionProps> = ({
  title,
  locked = false,
  lockedHint,
  lockedKeepOpen = false,
  open,
  onToggle,
  defaultOpen = true,
  children,
}) => {
  const [internalOpen, setInternalOpen] = useState(defaultOpen && !locked);
  const isControlled = open !== undefined;
  const isOpen =
    locked && lockedKeepOpen ? true : (isControlled ? !!open : internalOpen) && !locked;

  const toggle = (): void => {
    if (locked) return;
    if (isControlled) onToggle?.(!isOpen);
    else setInternalOpen((prev) => !prev);
  };

  return (
    <div className={`opms__accordion${locked ? ' opms__accordion--locked' : ''}`}>
      <div
        className="opms__accordion-header"
        onClick={toggle}
        role="button"
        aria-expanded={isOpen}
        aria-disabled={locked}
      >
        <div className="opms__accordion-title">
          {locked && (
            <svg className="opms__accordion-lock" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
              <path
                fill="currentColor"
                d="M12 1a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-1V6a5 5 0 0 0-5-5Zm3 8H9V6a3 3 0 0 1 6 0v3Z"
              />
            </svg>
          )}
          <span>{title}</span>
          {locked && lockedHint && <span className="opms__accordion-hint">{lockedHint}</span>}
        </div>
        <svg
          className={`opms__accordion-chevron${isOpen ? ' opms__accordion-chevron--open' : ''}`}
          viewBox="0 0 24 24"
          width="20"
          height="20"
          aria-hidden="true"
          focusable="false"
        >
          <path fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" d="m6 9 6 6 6-6" />
        </svg>
      </div>
      {isOpen && <div className="opms__accordion-body">{children}</div>}
    </div>
  );
};

export default OperationAnalyseAccordion;
